export enum PaperElevation {
  BOTTOM = 0,
  LOW = 3,
  MIDDLE = 5,
  HIGH = 10,
}

export enum FontSize {
  LOGIN_HEADER = "2rem",
  STONE_NAME = "32px",

  MEDIUM_SMALL = "12px",
  MEDIUM = "16px",
  MEDIUM_LARGE = "20px",

  LARGE = "24px",
}

export enum FontColor {
  WHITE = "#FFFFFF",
  BLUE = "#2C98F0",
  GRAY = "#878787",
}

export enum BackgroundColor {
  TOPNAVI_BG = "#FFFFFF",
  SUBNAVI_BG = "#454D57",

  BUTTON_BG_PINK = "#FF6B6B",
  BUTTON_BG_GRAY = "#ABABAB",

  BLUE = "#2C98F0",

  CONTENTS_BG = "#E9E9E9", //구역식별용 임시
}

export enum Border {
  DEFAULT_BORDER = "1px solid #bbbbbb",
  SUBNAVI_BORDER = "1px solid #5F6976",
}

export enum Padding {
  LOGIN_CONTAINER = "30px 20px 30px 20px",
  CONTENTS_CONTAINER = "50px",
}
